document.addEventListener("click", function(event) {
    var target = event.target;
    if (target.closest('.sizechart_text-svg')) {
        var overlay = document.querySelector(".sizechart-popup-overlay");
        if (overlay) {
            overlay.classList.add("showoverlay");
        }
        var popup = document.querySelector(".custom_prosize_popup_outer");
        if (popup) {
            popup.classList.add("show_sizechart");
        }
    }
});
document.addEventListener("click", function(event) {
    var target = event.target;
    if (target.closest('.size-modal-close')) {
        var overlay = document.querySelector(".sizechart-popup-overlay");
        if (overlay) {
            overlay.classList.remove("showoverlay");
        }
        var popup = document.querySelector(".custom_prosize_popup_outer");
        if (popup) {
            popup.classList.remove("show_sizechart");
        }
    }
});
document.addEventListener("mouseup", function(e) {
    var modalInner = document.querySelector(".product-sizing-modal-inner");
    if (modalInner && !modalInner.contains(e.target)) {
        var overlay = document.querySelector(".sizechart-popup-overlay");
        if (overlay) {
            overlay.classList.remove("showoverlay");
        }
        var popup = document.querySelector(".custom_prosize_popup_outer");
        if (popup) {
            popup.classList.remove("show_sizechart");
        }
    }
});
    document.addEventListener('DOMContentLoaded', function () {

   const swiper = new Swiper('.upsell_products_slider', {
      loop: true,
      // autoplay: {
      //   delay: 7000,
      //   disableOnInteraction: false,
      // },
      navigation: {
        nextEl: '.swiper-button-next-new',
        prevEl: '.swiper-button-prev-new',
      },
      spaceBetween: 10,
    });
    });

document.addEventListener("change", function(event) {
    if (event.target.matches(".variant_selector_wrapp select")) {
        var selectElement = event.target;
        var data_id = selectElement.value;
        var data_available = selectElement.options[selectElement.selectedIndex].getAttribute("variant-available");
        
        var upsellProductVariantsCart = selectElement.closest(".upsell_products_variants_cart");
        var addButton = upsellProductVariantsCart.querySelector(".upsell_products_addbtn button");
        
        addButton.setAttribute("data-id", data_id);
        
        if (data_available === "true") {
            addButton.textContent = "Add To Cart";
            addButton.removeAttribute("disabled");
            upsellProductVariantsCart.querySelector(".upsell_products_addbtn").classList.remove("sold_out_product");
        } else {
            addButton.textContent = "Sold Out";
            addButton.setAttribute("disabled", "disabled");
            upsellProductVariantsCart.querySelector(".upsell_products_addbtn").classList.add("sold_out_product");
        }
    }
});
document.addEventListener("click", function(event) {
  if (event.target && event.target.classList.contains("upsell_custom_button")) {
    var custom_var_id = event.target.getAttribute("data-id");
    let formData = {
      'items': [{
        'id': custom_var_id,
        'quantity': 1
      }]
    };
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      fetch('/')
        .then(response => response.text())
        .then(cart => {
          var cartDrawer = document.querySelector('#CartDrawer');
          var cartDrawerContent = new DOMParser().parseFromString(cart, 'text/html').querySelector('#CartDrawer').innerHTML;
          cartDrawer.innerHTML = cartDrawerContent;

 var cart_count = document.querySelector('.cart-count-bubble');
          var cartcountcontent = new DOMParser().parseFromString(cart, 'text/html').querySelector('.cart-count-bubble').innerHTML;
   const swiper = new Swiper('.upsell_products_slider', {
      loop: true,
      autoplay: {
        delay: 7000,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: '.swiper-button-next-new',
        prevEl: '.swiper-button-prev-new',
      },
      spaceBetween: 10,
    });
        });
      return response.json();
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }
});

document.addEventListener("click", function(event) {
    var targetElement = event.target.closest(".mobile_accordion_active");
    if (targetElement) {
        targetElement.classList.toggle("active_accordion");
        var parent = targetElement.closest(".footer-block.grid__item");
        var accordionContent = parent.querySelector(".accordion_content_active_here");
        if (accordionContent) {
            accordionContent.classList.toggle("accordion_show");
        }
    }
});
$(document).ready(function () {
  $(".swatch-input__label").eq(0).click();
});
